var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// source/assets/scripts/custom.js
var newDate = /* @__PURE__ */ new Date();
window.currentTime = newDate.getTime();
if (window.oldTime) {
  setTimeout(() => {
    window.location.reload();
  }, 100);
}
window.oldTime = window.currentTime;
function cleanUrlParams(url) {
  if (!url) return url;
  return url.split("?")[0];
}
var ComponentRegistry = {
  registeredVersions: /* @__PURE__ */ new Map(),
  /**
   * Safely define or redefine a custom element
   * @param {string} name - Custom element name
   * @param {class} componentClass - Component class definition
   */
  define(name, componentClass) {
    try {
      if (!customElements.get(name)) {
        customElements.define(name, componentClass);
        this.registeredVersions.set(name, 1);
        return;
      }
      const version = (this.registeredVersions.get(name) || 0) + 1;
      const versionedName = `${name}-v${version}`;
      customElements.define(versionedName, componentClass);
      this.registeredVersions.set(name, version);
      this.replaceInstances(name, versionedName);
    } catch (error) {
      console.error(`Failed to register component ${name}:`, error);
    }
  },
  /**
   * Replace existing component instances with the new version
   * @param {string} oldName - Original component name
   * @param {string} newName - New component name
   */
  replaceInstances(oldName, newName) {
    requestAnimationFrame(() => {
      const instances = document.querySelectorAll(oldName);
      instances.forEach((oldInstance) => {
        if (!oldInstance || !oldInstance.parentNode) return;
        const newInstance = document.createElement(newName);
        Array.from(oldInstance.attributes).forEach((attr) => {
          newInstance.setAttribute(attr.name, attr.value);
        });
        newInstance.innerHTML = oldInstance.innerHTML;
        oldInstance.parentNode.replaceChild(newInstance, oldInstance);
      });
    });
  }
};
window.ComponentRegistry = ComponentRegistry;
var CustomProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    this.pairContainer = this.querySelector("[data-pair-recommendations]");
    this.similarContainer = this.querySelector(
      "[data-similar-recommendations]"
    );
    this.searchEndpoint = `${window.Shopify.routes.root}search?section_id=${this.dataset.sectionId}&type=product&q=`;
    this.isLoading = false;
    this.categoryRelations = {
      SAREES: ["BLOUSE", "SHAPEWEAR"],
      "KURTA SET": ["EARRINGS"],
      "NECKLACE SET": ["SAREES", "KURTA SET"],
      TOP: ["BOTTOM WEAR", "EARRINGS"],
      KURTIS: ["BOTTOM WEAR"],
      "BOTTOM WEAR": ["KURTIS", "KURTA SET"],
      EARRINGS: ["SAREES", "KURTA SET", "KURTIS"],
      BLOUSE: ["SAREES", "SHAPEWEAR"],
      SHAPEWEAR: ["SAREES", "BLOUSE"]
    };
    this.categoryTerms = {
      SAREES: ["saree", "sari"],
      "KURTA SET": ["kurta-set", "kurta-palazzo", "kurta-pant", "kurta"],
      "NECKLACE SET": ["necklace-set", "necklace", "jewellery-set"],
      TOP: ["top", "tops"],
      KURTIS: ["kurti", "kurtis"],
      "BOTTOM WEAR": ["pant", "palazzo", "bottom", "trouser", "legging"],
      EARRINGS: ["earring", "ear-ring", "jhumka"],
      BLOUSE: ["blouse", "choli"],
      "CO-ORDS": ["co-ord", "coord"],
      DRESSES: ["dress", "gown"],
      SHAPEWEAR: ["shapewear", "petticoat"],
      "DRESS MATERIAL": ["dress-material", "unstitched"],
      SHIRT: ["shirt"],
      BODYCON: ["bodycon"],
      DUPATTAS: ["dupatta", "stole", "scarf"]
    };
    this.categoryTitles = {
      SAREES: "Complete Your Saree Look",
      "KURTA SET": "Pair with Your Kurta Set",
      "NECKLACE SET": "Perfect Match Jewelry Sets",
      TOP: "Style Your Top",
      KURTIS: "Complete Your Kurti Look",
      "BOTTOM WEAR": "Matching Bottom Wear",
      EARRINGS: "Complete Your Look with Earrings",
      BLOUSE: "Matching Blouses",
      "CO-ORDS": "Style Your Co-ords",
      DRESSES: "Complete Your Dress Look",
      SHAPEWEAR: "Essential Shapewear",
      "DRESS MATERIAL": "Style Your Dress Material",
      SHIRT: "Style Your Shirt",
      BODYCON: "Style Your Bodycon",
      DUPATTAS: "Matching Dupattas"
    };
  }
  connectedCallback() {
    this.loadRecommendations();
  }
  getProductCategory(product) {
    var _a, _b, _c;
    const handle = (_a = product.handle) == null ? void 0 : _a.toLowerCase();
    const type = (_b = product.type) == null ? void 0 : _b.toLowerCase();
    const title = (_c = product.title) == null ? void 0 : _c.toLowerCase();
    for (const [category, terms] of Object.entries(this.categoryTerms)) {
      if (terms.some(
        (term) => (type == null ? void 0 : type.includes(term.toLowerCase())) || (handle == null ? void 0 : handle.includes(term.toLowerCase())) || (title == null ? void 0 : title.includes(term.toLowerCase()))
      )) {
        return category;
      }
    }
    return null;
  }
  getRecommendedCategories(mainCategory) {
    return this.categoryRelations[mainCategory] || [];
  }
  createCategorySection(category) {
    const section = document.createElement("div");
    section.className = "category-section bg-white rounded-lg shadow-sm tw-mb-6";
    section.innerHTML = `
      <div class="title-wrapper tw-mt-12 center">
        <h3 class="title tw-text-center h2">${this.categoryTitles[category] || category}</h3>
      </div>
      <slider-component class="slider-mobile-gutter">
        <ul class="product-grid grid no-grow grid--2-col grid--3-col-tablet grid--4-col-desktop"
            role="list"
            data-category="${category}">
        </ul>
      </slider-component>
    `;
    return section;
  }
  calculateSavings(compareAtPrice, price) {
    if (!compareAtPrice || !price) return 0;
    return Math.trunc((compareAtPrice - price) * 100 / compareAtPrice);
  }
  fetchProductMarkup(productIds) {
    return __async(this, null, function* () {
      if (!productIds.length) return "";
      const queryString = productIds.map((id) => `id:${id}`).join(" OR ");
      try {
        const response = yield fetch(
          this.searchEndpoint + encodeURIComponent(queryString)
        );
        const html = yield response.text();
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.querySelector(".product-grid--resutls");
      } catch (error) {
        console.error("Error fetching product markup:", error);
        return "";
      }
    });
  }
  displayCategorizedProducts(products, mainProduct) {
    return __async(this, null, function* () {
      const mainCategory = this.getProductCategory(mainProduct);
      if (!mainCategory) return;
      const recommendedCategories = this.getRecommendedCategories(mainCategory);
      const categorizedProducts = {};
      products.forEach((product) => {
        const category = this.getProductCategory(product);
        if (category && recommendedCategories.includes(category)) {
          if (!categorizedProducts[category]) {
            categorizedProducts[category] = [];
          }
          categorizedProducts[category].push(product.id);
        }
      });
      this.pairContainer.innerHTML = "";
      for (const category of recommendedCategories) {
        const productIds = categorizedProducts[category] || [];
        if (productIds.length) {
          const productGrid = yield this.fetchProductMarkup(productIds);
          if (productGrid) {
            const section = document.createElement("div");
            section.className = "category-section bg-white rounded-lg shadow-sm tw-mb-6";
            section.innerHTML = `
            <div class="title-wrapper tw-mt-12 center">
              <h3 class="title tw-text-center h2">${this.categoryTitles[category] || category}</h3>
            </div>
            <slider-component class="slider-mobile-gutter" data-category="${category}">
              ${productGrid.outerHTML}
            </slider-component>
          `;
            this.pairContainer.appendChild(section);
          }
        }
      }
    });
  }
  loadRecommendations() {
    return __async(this, null, function* () {
      var _a, _b;
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const response = yield fetch(
          "https://asia-south1-plasma-renderer-442106-m5.cloudfunctions.net/RFY_CF_sudathi",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": "3602d36aeb1041cea20abd2c960b4ce1"
            },
            body: JSON.stringify({
              product_id: this.dataset.productId.toString()
            })
          }
        );
        if (!response.ok) throw new Error("Network response was not ok");
        const data = yield response.json();
        if ((_a = data.pair_it_with_product) == null ? void 0 : _a.length) {
          const mainProduct = {
            handle: this.dataset.handle,
            type: this.dataset.type,
            title: this.dataset.title
          };
          yield this.displayCategorizedProducts(
            data.pair_it_with_product,
            mainProduct
          );
        }
        if ((_b = data.similar_product) == null ? void 0 : _b.length) {
          const similarProductIds = data.similar_product.filter((product) => product.available).map((product) => product.id);
          const productGrid = yield this.fetchProductMarkup(similarProductIds);
          if (productGrid) {
            this.similarContainer.innerHTML = productGrid.innerHTML;
          }
        } else {
          this.hideSection(this.similarContainer);
        }
      } catch (error) {
        console.error("Error fetching recommendations:", error);
        this.hideSection(this.pairContainer);
        this.hideSection(this.similarContainer);
      } finally {
        this.isLoading = false;
      }
    });
  }
  hideSection(container) {
    const section = container.closest(".recommendations-section");
    if (section) {
      section.style.display = "none";
    }
  }
};
ComponentRegistry.define(
  "custom-product-recommendations",
  CustomProductRecommendations
);
function updateVisitorCount() {
  var vistorCountElement = document.querySelector("#vistorCount.product__text");
  var currentHourElement = document.querySelector("#currentHour");
  if (vistorCountElement && currentHourElement) {
    vistorCountElement.style.display = "flex";
    currentHourElement.style.display = "none";
    var randomCount = Math.floor(Math.random() * (500 - 300 + 1)) + 300;
    var strongElement = vistorCountElement.querySelector("strong");
    if (strongElement) {
      strongElement.innerText = randomCount;
    }
  }
}
function updateCurrentHour() {
  var vistorCountElement = document.querySelector("#vistorCount.product__text");
  var currentHourElement = document.querySelector("#currentHour");
  if (currentHourElement && vistorCountElement) {
    currentHourElement.style.display = "flex";
    vistorCountElement.style.display = "none";
    var currentDate = /* @__PURE__ */ new Date();
    var currentHour = currentDate.getHours();
    var currentMinute = currentDate.getMinutes();
    currentHour = currentHour % 12 || 12;
    var totalMinutes = currentHour * 60 + currentMinute;
    var outputValue = totalMinutes < 400 ? 450 + currentMinute : totalMinutes;
    var productId = meta.product.id;
    var lastDigit = productId % 10;
    outputValue += lastDigit;
    var strongElement = currentHourElement.querySelector("strong");
    if (strongElement) {
      strongElement.innerText = outputValue;
    }
  }
}
updateVisitorCount();
var showingVisitorCount = true;
setInterval(function() {
  if (showingVisitorCount) {
    updateCurrentHour();
  } else {
    updateVisitorCount();
  }
  showingVisitorCount = !showingVisitorCount;
}, 3e3);
var GiftSelector = class extends HTMLElement {
  constructor() {
    super();
    this.selectedGift = null;
    this.cartValue = 0;
    this.loading = false;
  }
  connectedCallback() {
    this.render();
    this.fetchCartValue();
    this.attachEventListeners();
  }
  fetchCartValue() {
    return __async(this, null, function* () {
      try {
        const res = yield fetch("/cart.json");
        const cart = yield res.json();
        this.cartValue = cart.total_price / 100;
        this.render();
      } catch (error) {
        console.error("Error fetching cart:", error);
      }
    });
  }
  handleGiftSelect(giftType) {
    if (this.selectedGift === giftType) {
      this.selectedGift = null;
    } else {
      this.selectedGift = giftType;
    }
    this.render();
  }
  attachEventListeners() {
    this.addEventListener("click", (e) => {
      if (e.target.matches("[data-gift-select]")) {
        const giftType = e.target.dataset.giftType;
        this.handleGiftSelect(giftType);
      }
    });
  }
  renderGiftOption(type, threshold, title) {
    const isEligible = this.cartValue >= threshold;
    const isSelected = this.selectedGift === type;
    return `
      <div class="tw-rounded-lg tw-border tw-p-4 tw-mb-4 ${isEligible ? "tw-bg-white" : "tw-bg-gray-50"}">
        <div class="tw-flex tw-items-center tw-justify-between">
          <div class="tw-flex tw-items-center tw-space-x-3">
            <div class="tw-w-6 tw-h-6 tw-rounded-full tw-border tw-flex tw-items-center tw-justify-center 
              ${isSelected ? "tw-bg-blue-600 tw-border-blue-600" : "tw-border-gray-300"}">
              ${isSelected ? '<svg class="tw-w-4 tw-h-4 tw-text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>' : ""}
            </div>
            <div>
              <h3 class="tw-font-medium tw-text-gray-900">${title}</h3>
              <p class="tw-text-sm tw-text-gray-500">
                ${isEligible ? "Available with your purchase" : `Available when you spend $${threshold}`}
              </p>
            </div>
          </div>
          ${type === "gift-at-99" ? '<span class="tw-text-sm tw-font-medium tw-text-gray-900">$99</span>' : '<span class="tw-text-sm tw-font-medium tw-text-green-600">FREE</span>'}
        </div>
        
        <div class="tw-mt-4">
          <img 
            src="/api/placeholder/200/150"
            alt="Gift preview"
            class="tw-w-full tw-h-40 tw-object-cover tw-rounded-md"
          />
        </div>

        <button
          data-gift-select
          data-gift-type="${type}"
          ${!isEligible ? "disabled" : ""}
          class="tw-mt-4 tw-w-full tw-py-2 tw-px-4 tw-rounded-md tw-text-sm tw-font-medium
            ${isEligible ? isSelected ? "tw-bg-blue-100 tw-text-blue-700 hover:tw-bg-blue-200" : "tw-bg-blue-600 tw-text-white hover:tw-bg-blue-700" : "tw-bg-gray-100 tw-text-gray-400 tw-cursor-not-allowed"}"
        >
          ${isSelected ? "Remove Gift" : "Add Gift"}
        </button>
      </div>
    `;
  }
  render() {
    this.innerHTML = `
      <div class="tw-w-full tw-max-w-md tw-mx-auto tw-p-4 tw-bg-white">
        <div class="tw-mb-6">
          <h2 class="tw-text-xl tw-font-semibold tw-text-gray-900 tw-mb-2">Add a Gift</h2>
          <p class="tw-text-sm tw-text-gray-600">Select a special gift with your purchase</p>
        </div>

        ${this.renderGiftOption("gift-at-99", 99, "Premium Gift Box")}
        ${this.renderGiftOption("free-gift", 150, "Special Gift")}

        ${this.loading ? `
          <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
            <div class="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-b-2 tw-border-blue-600"></div>
          </div>
        ` : ""}
      </div>
    `;
  }
};
ComponentRegistry.define("gift-selector", GiftSelector);
var DiscountedBundle = class extends BundleProducts {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.forms = new Array();
    const inputs = document.querySelectorAll(`[value="${this.productId}"]`);
    inputs.forEach((input) => {
      input.closest("form") ? this.forms.push(input.closest("form")) : null;
    });
    this.productPickers = this.querySelectorAll("product-picker");
    this.productPickers.forEach((picker) => {
      picker.addEventListener("productPicked", this.onProductPicked.bind(this));
      picker.addEventListener(
        "productRemoved",
        this.onProductRemoved.bind(this)
      );
    });
  }
  onProductPicked(event) {
    this.dataset.selected = "true";
  }
  onProductRemoved(event) {
    const anySelected = Array.from(this.productPickers).some(
      (picker) => picker.dataset.selected === "true"
    );
    this.dataset.selected = anySelected ? "true" : "false";
  }
  // Override the parent class's onButtonClick to add bundle property
  onButtonClick(event) {
    // console.log("Adding Bundle");
    event.preventDefault();
    const ids = this.querySelectorAll('[name="id"]');
    const items = {
      items: [...ids].map((e) => ({
        id: e.value,
        quantity: 1,
        properties: {
          _bundle: true
        }
      }))
    };
    if (items.items.length === 0) {
      return;
    }
    if (document.body.classList.contains("template-cart") || !theme.shopSettings.cartDrawer) {
      Shopify.postLink2(theme.routes.cart_add_url, {
        parameters: __spreadValues({}, items)
      });
      return;
    }
    this.handleErrorMessage();
    const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
    const body = JSON.stringify(__spreadProps(__spreadValues({}, items), {
      sections,
      sections_url: window.location.pathname
    }));
    fetch(`${theme.routes.cart_add_url}`, __spreadProps(__spreadValues({}, fetchConfig("javascript")), {
      body
    })).then((response) => response.json()).then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }
      if (response.status === 422) {
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:error", {
            detail: {
              errorMessage: response.description
            }
          })
        );
      } else {
        this.miniCart && this.miniCart.renderContents(response);
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: response
            }
          })
        );
      }
    }).catch((e) => {
      console.error(e);
    });
  }
};
ComponentRegistry.define("discounted-bundle", DiscountedBundle);
var CollectionGrid = class extends HTMLElement {
  connectedCallback() {
    this.productPicker = this.closest("product-picker");
  }
  loadContent() {
    if (true) {
      this.cloneRecommendations();
    } else {
      this.loadCollectionContent();
    }
  }
  cloneRecommendations() {
    if (productData.type === "Sarees") {
      const blouses = document.querySelector('[data-category="BLOUSE"]');
      const shapewear = document.querySelector('[data-category="SHAPEWEAR"]');
      if (this.productPicker.dataset.blockId == 2) {
        this.innerHTML = blouses.outerHTML;
        this.updateProductCards();
      }
      if (this.productPicker.dataset.blockId == 3) {
        this.innerHTML = shapewear.outerHTML;
        this.updateProductCards();
      }
    }
  }
  loadCollectionContent() {
    const productPicker = this.productPicker;
    if (!productPicker) return;
    const url = productPicker.dataset.collectionUrl;
    if (!url) {
      console.error("Error: Collection URL not found");
      return;
    }
    fetch(url).then((response) => {
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      return response.text();
    }).then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const productGrid = doc.querySelector("#product-grid");
      if (!productGrid) {
        throw new Error("Product grid not found in the response");
      }
      this.innerHTML = productGrid.outerHTML;
      this.updateProductCards();
    }).catch((error) => {
      console.error("Error loading collection:", error);
    });
  }
  updateProductCards() {
    this.querySelectorAll(".card-wrapper").forEach((card) => {
      this.updateBundleButton(card);
      this.updatePrice(card);
    });
  }
  updateBundleButton(card) {
    var _a;
    (_a = card.querySelector(".product__media-icon--similar")) == null ? void 0 : _a.classList.add("hidden");
    const button = card.querySelector(
      "add-to-cart, quick-view-button, .card-information__button .button--view-product"
    );
    if (!button) return;
    const addToBundle = document.createElement("add-to-bundle");
    addToBundle.setAttribute(
      "data-product-url",
      button.dataset.productUrl || button.href
    );
    if (button.classList.length) {
      addToBundle.className = button.classList.value;
      addToBundle.classList.add("button--full-width");
    }
    const buttonText = document.createElement("span");
    buttonText.className = "button__text";
    buttonText.textContent = "Select";
    addToBundle.appendChild(buttonText);
    button.replaceWith(addToBundle);
  }
  updatePrice(card) {
    var _a;
    const priceEl = card.querySelector(".price-item.price-item--sale");
    if (!priceEl) return;
    const priceMoney = priceEl.querySelector("price-money");
    if (!priceMoney) return;
    const bdi = priceMoney.querySelector("bdi");
    if (!bdi) return;
    try {
      const originalPrice = parseFloat(priceEl.dataset.price || "0");
      if (isNaN(originalPrice)) return;
      const newPrice = (originalPrice / 100 * 0.6).toFixed(2);
      const currencySymbol = ((_a = bdi.querySelector(".price__prefix")) == null ? void 0 : _a.textContent) || "\u20B9";
      bdi.innerHTML = `${theme.Currency.formatMoney(
        newPrice,
        theme.shopSettings.moneyFormat
      )}`;
      if (typeof priceMoney.init === "function") {
      }
    } catch (error) {
      console.error("Error updating price:", error);
    }
  }
};
ComponentRegistry.define("collection-grid", CollectionGrid);
var AddToBundle = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.addToBundle.bind(this));
  }
  addToBundle() {
    const productPicker = this.closest("product-picker");
    if (!productPicker) return;
    const blockId = productPicker.dataset.blockId;
    const pickedProduct = document.querySelector(
      `picked-bundle-product[data-block-id="${blockId}"]`
    );
    if (pickedProduct) {
      pickedProduct.addProduct(this.dataset.productUrl);
      pickedProduct.classList.remove("hidden");
      const modal = this.closest("modal-dialog");
      if (modal) {
        modal.querySelector(".product-popup-modal__toggle").click();
      }
    }
  }
};
ComponentRegistry.define("add-to-bundle", AddToBundle);
var PickedBundleProduct = class extends BundleProduct {
  constructor() {
    super();
    this.setupRemoveButton();
    const blockId = this.dataset.blockId;
    this.productPicker = document.querySelector(
      `product-picker[data-block-id="${blockId}"]`
    );
  }
  setupRemoveButton() {
    this.button = this.querySelector(".button-bundle-remove");
    if (this.button) {
      this.button.addEventListener("click", this.removeProduct.bind(this));
    }
  }
  addProduct(url) {
    return __async(this, null, function* () {
      try {
        const cleanUrl = cleanUrlParams(url);
        const response = yield fetch(`${cleanUrl}.js`);
        const product = yield response.json();
        const containerInner = this.querySelector(".product-container--inner");
        if (!containerInner) return;
        const productHTML = this.generateProductHTML(product);
        containerInner.innerHTML = productHTML;
        const placeholder = this.querySelector(".product-placeholder");
        if (placeholder) {
        }
        containerInner.querySelectorAll("a").forEach((anchor) => {
          if (anchor.href) {
            anchor.href = cleanUrlParams(anchor.href);
          }
        });
        this.setupRemoveButton();
        this.setupVariantListener();
        this.productPicker.dataset.selected = "true";
        this.productPicker.dispatchEvent(
          new CustomEvent("productPicked", {
            bubbles: true,
            detail: { blockId: this.dataset.blockId }
          })
        );
      } catch (error) {
        console.error("Error adding product:", error);
        this.resetToPlaceholder();
      }
    });
  }
  removeProduct() {
    this.productPicker.dataset.selected = "false";
    if (this.productPicker) {
      const opener = this.productPicker.querySelector(
        ".product-popup-modal__opener"
      );
      if (opener) {
        opener.classList.remove("hidden");
      }
    }
    this.resetToPlaceholder();
    this.productPicker.dispatchEvent(
      new CustomEvent("productRemoved", {
        bubbles: true,
        detail: { blockId: this.dataset.blockId }
      })
    );
  }
  resetToPlaceholder() {
    const container = this.querySelector(".product-container--inner");
    if (container) {
      container.innerHTML = "";
    }
    const placeholder = this.querySelector(".product-placeholder");
    if (placeholder) {
      placeholder.classList.remove("hidden");
    }
  }
  setupVariantListener() {
    const select = this.querySelector("select");
    if (select) {
      select.addEventListener("change", this.onVariantChange.bind(this));
    }
  }
  generateProductHTML(product) {
    product.variants.forEach((variant) => {
      variant.price = variant.price * 0.6;
    });
    const selectedVariant = product.variants.find((variant) => variant.available) || product.variants[0];
    const cleanProductUrl = cleanUrlParams(product.url);
    return `
      ${this.generateImageHTML(product)}
      <div class="product-description">
        <div class="product-content">
          <div>
            <a href="${cleanProductUrl}" target="_blank" class="product-title h4">${product.title}</a>
        ${this.generatePriceHTML(selectedVariant)}

        <div class="price--discount" price="${selectedVariant.price}">Additional 40% off</div>
        <div class="price--original" price="${selectedVariant.price}">${theme.Currency.formatMoney(
      (selectedVariant.price * 5 / 3).toFixed(0),
      theme.shopSettings.moneyFormat
    )}</div>
          </div>
          ${product.available ? `
            <div class="product-button">
              ${this.generateVariantsHTML(product)}
            </div>
          ` : ""}
        </div>
      </div>
      <button type="button" class="button-bundle-remove button--cta button--small">
        <span class="visually-hidden">Remove product</span>
        <svg class="icon icon-close" viewBox="0 0 18 18">
          <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/>
        </svg>
      </button>
    `;
  }
  generateImageHTML(product) {
    if (!product.featured_image) return "";
    const cleanProductUrl = cleanUrlParams(product.url);
    return `
      <div class="product-image">
        <a href="${cleanProductUrl}" class="media-wrapper media-wrapper--small">
          <div class="media media--adapt">
            <img 
              srcset="${product.featured_image}&width=70 1x, ${product.featured_image}&width=140 2x"
              src="${product.featured_image}?width=70"
              alt="${product.title}"
              width="70"
              height="auto"
              loading="lazy"
              is="lazy-image"
            />
          </div>
        </a>
      </div>
    `;
  }
  generateVariantsHTML(product) {
    if (product.variants.length <= 1) {
      const availableVariant = product.variants.find(
        (variant) => variant.available
      );
      return `<input type="hidden" name="id" value="${(availableVariant == null ? void 0 : availableVariant.id) || product.variants[0].id}" />`;
    }
    return `
      <select-wrapper class="select">
        <select class="select__select" name="id">
          ${product.variants.map(
      (variant) => `
            <option
              value="${variant.id}"
              data-available="${variant.available}"
              data-price="${variant.price}"
              data-compare_at_price="${variant.compare_at_price}"
              ${variant.available && variant.id === product.variants[0].id ? 'selected="selected"' : ""}
              ${!variant.available ? 'disabled="disabled"' : ""}
            >
              ${variant.title}${!variant.available ? " - Sold out" : ""}
            </option>
          `
    ).join("")}
        </select>
        <svg class="icon icon-caret" viewBox="0 0 10 6">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"/>
        </svg>
      </select-wrapper>
    `;
  }
  generatePriceHTML(variant) {
    const priceClasses = [
      "price",
      !variant.available ? "price--sold-out" : "",
      variant.compare_at_price > variant.price ? "price--on-sale" : ""
    ].filter(Boolean).join(" ");
    return `
      <div class="${priceClasses}">
        <div class="price__regular">
          <span class="price-item price-item--regular">
            <price-money><bdi>${theme.Currency.formatMoney(
      variant.price,
      theme.shopSettings.moneyFormat
    )}</bdi></price-money>
          </span>
        </div>
        <div class="price__sale">
          <span class="price__compare">
            <s class="price-item price-item--regular">
              <price-money><bdi>${theme.Currency.formatMoney(
      variant.compare_at_price,
      theme.shopSettings.moneyFormat
    )}</bdi></price-money>
            </s>
          </span>
          <span class="price-item price-item--sale">
            <price-money><bdi>${theme.Currency.formatMoney(
      variant.price,
      theme.shopSettings.moneyFormat
    )}</bdi></price-money>
          </span>
        </div>
        ${!variant.available ? `
          <span class="badge price__badge-sold-out" aria-hidden="true">Sold out</span>
        ` : ""}
      </div>
    `;
  }
  onVariantChange(event) {
    const select = event.target;
    const selectedOption = select.options[select.selectedIndex];
    const price = parseFloat(selectedOption.dataset.price);
    const comparePrice = parseFloat(selectedOption.dataset.compare_at_price);
    const available = selectedOption.dataset.available === "true";
    const priceContainer = this.querySelector(".price");
    if (!priceContainer) return;
    priceContainer.classList.toggle("price--on-sale", comparePrice > price);
    priceContainer.classList.toggle("price--sold-out", !available);
    const moneyFormat = theme.shopSettings.moneyFormat;
    const formattedPrice = theme.Currency.formatMoney(price, moneyFormat);
    const formattedComparePrice = theme.Currency.formatMoney(
      comparePrice,
      moneyFormat
    );
    const regularPrice = priceContainer.querySelector(
      ".price-item--regular price-money bdi"
    );
    const salePrice = priceContainer.querySelector(
      ".price-item--sale price-money bdi"
    );
    const compareAtPrice = priceContainer.querySelector(
      ".price__compare price-money bdi"
    );
    if (regularPrice) regularPrice.innerHTML = formattedPrice;
    if (salePrice) salePrice.innerHTML = formattedPrice;
    if (compareAtPrice) compareAtPrice.innerHTML = formattedComparePrice;
  }
};
ComponentRegistry.define("picked-bundle-product", PickedBundleProduct);
document.addEventListener("DOMContentLoaded", function() {
  return __async(this, null, function* () {
    if (!sessionStorage.getItem("drop_pincode")) {
      try {
        let fillAndSubmitPincode2 = function() {
          if (pincodeInput && submitButton) {
            pincodeInput.value = data.postalCode;
            const inputEvent = new Event("input", { bubbles: true });
            pincodeInput.dispatchEvent(inputEvent);
            submitButton.click();
            return true;
          } else {
            attempts++;
            if (attempts < maxAttempts) {
              // console.log(
              //   `Elements not found on attempt ${attempts}, retrying in 300ms...`
              // );
              setTimeout(fillAndSubmitPincode2, 1e3);
            } else {
              console.error(
                `Could not find pincode input or submit button after ${maxAttempts} attempts`
              );
            }
            return false;
          }
        };
        var fillAndSubmitPincode = fillAndSubmitPincode2;
        const response = yield fetch(
          "https://api-ce86223c6008d1b20ba0.o2.myshopify.dev/geolocate"
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = yield response.json();
        sessionStorage.setItem("drop_pincode", data.postalCode);
        const pincodeInput = document.querySelector(
          ".clickpost-edd__drop_pincode-input"
        );
        const submitButton = document.querySelector(
          ".clickpost-edd__submit-button"
        );
        let attempts = 0;
        const maxAttempts = 3;
        fillAndSubmitPincode2();
      } catch (error) {
        console.error("Error fetching or processing geolocation data:", error);
      }
    }
  });
});
if (!customElements.get("pre-drape-service")) {
  customElements.define(
    "pre-drape-service",
    class PreDrapeService extends HTMLElement {
      constructor() {
        super();
        this.miniCart = document.querySelector("mini-cart");
        this.checkbox = this.querySelector('input[name="pre-drape"]');
        this.priceDisplay = this.querySelector(".pre-drape-price");
        this.measurementsContainer = this.querySelector(
          ".pre-drape-measurements"
        );
        this.measurementFields = this.querySelectorAll(
          ".measurement-field input"
        );
        if (this.checkbox) {
          this.checkbox.addEventListener(
            "change",
            this.onCheckboxChange.bind(this)
          );
        }
        this.measurementFields.forEach((field) => {
          field.addEventListener("input", this.validateField.bind(this));
          field.addEventListener("blur", this.validateField.bind(this));
        });
      }
      onCheckboxChange(event) {
        if (this.priceDisplay) {
          this.priceDisplay.classList.toggle("hidden", !event.target.checked);
        }
        if (this.measurementsContainer) {
          this.measurementsContainer.classList.toggle(
            "active",
            event.target.checked
          );
          if (!event.target.checked) {
            this.measurementFields.forEach((field) => {
              field.value = "";
              this.clearFieldError(field);
            });
          }
        }
        this.dispatchEvent(
          new CustomEvent("pre-drape-change", {
            bubbles: true,
            detail: {
              checked: event.target.checked
            }
          })
        );
      }
      validateField(event) {
        const field = event.target;
        const value = parseFloat(field.value);
        let isValid = true;
        if (field.hasAttribute("data-measurement-required") && !field.value.trim()) {
          isValid = false;
        } else if (field.value.trim() && (isNaN(value) || value <= 0)) {
          isValid = false;
        } else if (field.hasAttribute("data-measurement-min") && value < parseFloat(field.getAttribute("data-measurement-min"))) {
          isValid = false;
        } else if (field.hasAttribute("data-measurement-max") && value > parseFloat(field.getAttribute("data-measurement-max"))) {
          isValid = false;
        }
        const fieldWrapper = field.closest(".measurement-field");
        const errorElement = fieldWrapper.querySelector(".field-error");
        if (isValid) {
          this.clearFieldError(field);
        } else {
          fieldWrapper.classList.add("has-error");
          if (errorElement) {
            errorElement.classList.add("show");
          }
        }
        return isValid;
      }
      clearFieldError(field) {
        const fieldWrapper = field.closest(".measurement-field");
        const errorElement = fieldWrapper.querySelector(".field-error");
        fieldWrapper.classList.remove("has-error");
        if (errorElement) {
          errorElement.classList.remove("show");
        }
      }
      validateAllFields() {
        let allValid = true;
        this.measurementFields.forEach((field) => {
          if (!this.validateField({ target: field })) {
            allValid = false;
          }
        });
        return allValid;
      }
      isSelected() {
        return this.checkbox && this.checkbox.checked;
      }
      getServiceProductId() {
        return this.dataset.preDrapeProductId || null;
      }
      getPreDrapeMeasurements() {
        const measurements = {};
        if (this.isSelected()) {
          this.measurementFields.forEach((field) => {
            if (field.name.startsWith("properties[") && field.value) {
              const propName = field.name.match(/\[(.*?)\]/)[1];
              measurements[propName] = field.value.trim();
            }
          });
        }
        return measurements;
      }
      onButtonClick(event) {
        var _a, _b, _c;
        if (!this.isSelected()) {
          return true;
        }
        if (!this.validateAllFields()) {
          event.preventDefault();
          return false;
        }
        const preDrapeProductId = this.getServiceProductId();
        const productForm = event.target.closest("product-form");
        const productSku = (_a = this.closest("product-info")) == null ? void 0 : _a.getAttribute("data-product-sku");
        const formData = new FormData(productForm.form);
        const variantId = formData.get("id");
        const measurements = this.getPreDrapeMeasurements();
        if (!preDrapeProductId || !variantId) {
          return false;
        }
        const items = [
          {
            id: variantId,
            quantity: 1,
            properties: __spreadValues({
              "Pre-draped": "Yes",
              "_productSku": productSku
            }, measurements)
          },
          {
            id: preDrapeProductId,
            quantity: 1,
            properties: {
              "_preDrapeService": "true",
              "_parentSku": productSku
            }
          }
        ];
        if (items.length === 0) {
          return false;
        }
        if (document.body.classList.contains("template-cart") || !theme.shopSettings.cartDrawer) {
          Shopify.postLink2(theme.routes.cart_add_url, {
            parameters: {
              items
            }
          });
          return true;
        }
        productForm.handleErrorMessage();
        const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
        const body = JSON.stringify({
          items,
          sections,
          sections_url: window.location.pathname
        });
        event.preventDefault();
        (_b = productForm.submitButton) == null ? void 0 : _b.setAttribute("aria-disabled", true);
        (_c = productForm.submitButton) == null ? void 0 : _c.classList.add("loading");
        fetch(`${theme.routes.cart_add_url}`, __spreadProps(__spreadValues({}, fetchConfig("javascript")), {
          body
        })).then((response) => response.json()).then((response) => {
          if (response.status) {
            productForm.handleErrorMessage(response.description);
            return;
          }
          if (response.status === 422) {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:error", {
                detail: {
                  errorMessage: response.description
                }
              })
            );
          } else {
            this.miniCart && this.miniCart.renderContents(response);
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: {
                  product: response
                }
              })
            );
            const quickAddModal = productForm.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.miniCart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            }
          }
        }).catch((e) => {
          console.error(e);
          productForm.handleErrorMessage(
            "An error occurred. Please try again."
          );
        }).finally(() => {
          var _a2, _b2;
          (_a2 = productForm.submitButton) == null ? void 0 : _a2.classList.remove("loading");
          if (this.miniCart && this.miniCart.classList.contains("is-empty"))
            this.miniCart.classList.remove("is-empty");
          if (!productForm.error)
            (_b2 = productForm.submitButton) == null ? void 0 : _b2.removeAttribute("aria-disabled");
        });
        return true;
      }
    }
  );
}
//# sourceMappingURL=custom.js.map






// ======================== 
//   PROGRESS BAR JS
// ========================
// document.addEventListener("DOMContentLoaded", function () {
//     function updateProgressBar() {
//         fetch('/cart.js')
//             .then(response => response.json())
//             .then(cart => {
//                 let subtotal = cart.total_price / 100; // Convert from paise to rupees
//                 let progressBar = document.getElementById("cart-progress-bar1");
//                 let message = document.getElementById("progress-messagee1");
//                 let progressContainer = document.getElementById("cart-progress-container1");

//                 // Max goal = ₹1999
//                 let progress = (subtotal / 1999) * 100;
//                 progress = Math.min(progress, 100);

//                 if (subtotal > 0) {
//                     progressContainer.style.display = "flex";
//                 } else {
//                     progressContainer.style.display = "none";
//                 }

//                 progressBar.style.width = progress + "%";

//                 // Update messaging
//                 if (subtotal < 999) {
//                     let remaining = 999 - subtotal;
//                     message.innerText = `Spend ₹${remaining.toFixed(0)} more — Get a FREE Saree Bag`;
//                 } else if (subtotal >= 999 && subtotal < 1999) {
//                     let remaining = 1999 - subtotal;
//                     message.innerText = `Spend ₹${remaining.toFixed(0)} more — Get a FREE Gold Box`;
//                 } else if (subtotal >= 1999) {
//                     message.innerText = "🎉 Congratulations! You've unlocked the offer!";
//                 }
//             });
//     }

//     // Listen for Shopify cart updates
//     document.addEventListener('cart:updated', function () {
//         updateProgressBar();
//     });

//     // Monitor fetch for cart changes
//     function monitorCartChanges() {
//         let originalFetch = window.fetch;
//         window.fetch = function (...args) {
//             return originalFetch(...args).then(response => {
//                 if (args[0].includes("/cart/add.js") || args[0].includes("/cart/update.js") || args[0].includes("/cart/change.js")) {
//                     updateProgressBar();
//                 }
//                 return response;
//             });
//         };
//     }

//     document.addEventListener("cart:updated", monitorCartChanges);
//     monitorCartChanges();

//     // Optional: Observe cart drawer DOM changes
//     let cartDrawer = document.getElementById('CartDrawer');
//     if (cartDrawer) {
//         let observer = new MutationObserver(updateProgressBar);
//         observer.observe(cartDrawer, { childList: true, subtree: true });
//     }

//     // Initial call
//     updateProgressBar();
// });


// =============
// cart-progress 
// =============





document.addEventListener("DOMContentLoaded", function () {





    function updateProgressBar() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let totalItems = cart.item_count;
                let progress = (totalItems / 3) * 100; // Max limit is 3 items
                progress = Math.min(progress, 100); // Ensure it doesn't exceed 100%

                let progressBar = document.getElementById("cart-progress-bar1");
                let message = document.getElementById("progress-messagee1");
                let progressContainer = document.getElementById("cart-progress-container1");

                if (totalItems > 0) {
                    progressContainer.style.display = "flex"; // Show progress bar if items exist
                } else {
                    progressContainer.style.display = "flex"; // Hide if empty
                }

                progressBar.style.width = progress + "%";

                // Update messaging
                if (totalItems === 0) {
                    message.innerText = " Add 3 products to unlock the offer!";
             
                } else if (totalItems === 1) {
                    message.innerText = "  Add 2 more products to unlock the offer!";
           

                } else if (totalItems === 2) {
                    message.innerText =  " Add 1 more product to unlock the offer!";
                  

                } else if (totalItems >= 3) {
                    message.innerText = "🎉 Congratulations! You've unlocked the offer!";
                    // triggerPartyPopper();
                }

                 ;
            });
    }

    // Initial check
  setTimeout(()=>{
    setInterval(()=>{
      updateProgressBar();
      // console.log('jjj')
    },1000)  
  },3000)
  

    // Function to monitor cart changes
    function monitorCartChanges() {
        let originalFetch = window.fetch;

        window.fetch = function (...args) {
            return originalFetch(...args).then(response => {
                if (args[0].includes("/cart/add.js") || args[0].includes("/cart/update.js") || args[0].includes("/cart/change.js")) {
                    updateProgressBar();
                }
                return response;
            });
        };
    }

    // Listen for Shopify AJAX cart updates
    document.addEventListener("cart:updated", monitorCartChanges);

    // Monitor cart updates in real-time
    monitorCartChanges();

    // MutationObserver to detect changes in the cart drawer
    let cartDrawer = document.getElementById('CartDrawer'); // Change this to your actual cart drawer ID or class
    if (cartDrawer) {
        let observer = new MutationObserver(updateProgressBar);
        observer.observe(cartDrawer, { childList: true, subtree: true });
    }
});



// Canvass #############################
// function triggerPartyPopper() {
//   const canvas = document.getElementById('partyCanvas');
//   const ctx = canvas.getContext('2d');

//   canvas.width = window.innerWidth;
//   canvas.height = window.innerHeight;

//   const originX = canvas.width / 2;
//   const originY = canvas.height - 100;

//   const emojis = ['🎉', '🎊', '💥', '❤️', '🤩'];
//   const shapes = ['rect', 'triangle', 'emoji'];

//   const particles = [];
//   const totalParticles = 100;

//   for (let i = 0; i < totalParticles; i++) {
//     const angle = Math.random() * Math.PI - Math.PI;
//     const speed = Math.random() * 8 + 1;
//     const shape = shapes[Math.floor(Math.random() * shapes.length)];

//     particles.push({
//       x: originX,
//       y: originY,
//       size: Math.random() * 6 + 4,
//       color: `hsl(${Math.random() * 360}, 100%, 60%)`,
//       velocityX: Math.cos(angle) * speed,
//       velocityY: Math.sin(angle) * speed - 8,
//       opacity: 1,
//       gravity: 0.25,
//       fade: Math.random() * 0.02 + 0.005,
//       rotation: Math.random() * 360,
//       rotationSpeed: (Math.random() - 0.5) * 10,
//       shape: shape,
//       emoji: emojis[Math.floor(Math.random() * emojis.length)]
//     });
//   }

//   let lastTime = performance.now();
//   const frameRate = 1000 / 60; // target ~60 FPS
//   let animationFrameId;

//   function drawFrame(currentTime) {
//     const delta = currentTime - lastTime;

//     if (delta >= frameRate) {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       particles.forEach(p => {
//         ctx.save();
//         ctx.globalAlpha = p.opacity;
//         ctx.translate(p.x, p.y);
//         ctx.rotate((p.rotation * Math.PI) / 180);

//         ctx.shadowColor = p.color;
//         ctx.shadowBlur = 10;

//         if (p.shape === 'circle') {
//           ctx.fillStyle = p.color;
//           ctx.beginPath();
//           ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
//           ctx.fill();
//         } else if (p.shape === 'rect') {
//           ctx.fillStyle = p.color;
//           ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
//         } else if (p.shape === 'triangle') {
//           ctx.fillStyle = p.color;
//           ctx.beginPath();
//           ctx.moveTo(0, -p.size / 2);
//           ctx.lineTo(-p.size / 2, p.size / 2);
//           ctx.lineTo(p.size / 2, p.size / 2);
//           ctx.closePath();
//           ctx.fill();
//         } else if (p.shape === 'emoji') {
//           ctx.shadowBlur = 0;
//           ctx.font = `${p.size * 2}px serif`;
//           ctx.fillText(p.emoji, -p.size / 2, p.size / 2);
//         }

//         ctx.restore();
//       });

//       updateParticles();
//       lastTime = currentTime;
//     }

//     animationFrameId = requestAnimationFrame(drawFrame);
//   }

//   function updateParticles() {
//     particles.forEach(p => {
//       p.x += p.velocityX;
//       p.y += p.velocityY;
//       p.velocityY += p.gravity;
//       p.opacity -= p.fade;
//       p.rotation += p.rotationSpeed;
//     });
//   }

//   animationFrameId = requestAnimationFrame(drawFrame);

//   // Stop after 4 seconds
//   setTimeout(() => {
//     cancelAnimationFrame(animationFrameId);
//     ctx.clearRect(0, 0, canvas.width, canvas.height);
//   }, 4000);
// }

function triggerPartyPopper(opts = {}) {
  const {
    durationMs = 4000,     // how long to run the show
    simFps     = 60,       // fixed physics rate
    particleCount = 120
  } = opts;

  const canvas = document.getElementById('partyCanvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');

  // Hi-DPI sizing
  function resize() {
    const dpr = Math.max(1, window.devicePixelRatio || 1);
    canvas.width  = Math.floor(window.innerWidth  * dpr);
    canvas.height = Math.floor(window.innerHeight * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0); // draw in CSS pixels
  }
  resize();
  window.addEventListener('resize', resize, { once: true });

  const originX = window.innerWidth / 2;
  const originY = window.innerHeight - 100;

  const emojis = ['🎉', '🎊', '💥', '❤️', '🤩'];
  const shapes = ['rect', 'triangle', 'emoji', 'circle']; // added circle

  // Build particles with time-based properties (units per second)
  const particles = [];
  for (let i = 0; i < particleCount; i++) {
    // launch spread: -80° to -100° (mostly upward with some sideways), adjust to taste
    const angle = (-90 + (Math.random() * 40 - 20)) * Math.PI / 180;
    const speed = 220 + Math.random() * 260;   // px/s
    const size  = 6 + Math.random() * 8;       // px (CSS pixels)
    const shape = shapes[Math.floor(Math.random() * shapes.length)];

    particles.push({
      x: originX,
      y: originY,
      size,
      color: `hsl(${Math.random() * 360}, 100%, 60%)`,
      vx: Math.cos(angle) * speed,             // px/s
      vy: Math.sin(angle) * speed - 120,       // px/s, initial upward kick
      opacity: 1,
      gravity: 480,                             // px/s²
      fadePerSec: 0.35 + Math.random() * 0.25, // opacity/s
      rotationDeg: Math.random() * 360,
      rotationSpeedDeg: (Math.random() * 240 - 120), // deg/s
      shape,
      emoji: emojis[Math.floor(Math.random() * emojis.length)],
      shadowBlur: 8
    });
  }

  // Fixed-timestep game loop (deterministic physics)
  const stepMs = 1000 / simFps;
  let accMs = 0;
  let last = performance.now();
  let elapsedMs = 0;
  let raf;

  function update(dt) { // dt in seconds
    for (const p of particles) {
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.vy += p.gravity * dt;
      p.opacity -= p.fadePerSec * dt;
      p.rotationDeg += p.rotationSpeedDeg * dt;
    }
  }

  function render() {
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    for (const p of particles) {
      if (p.opacity <= 0) continue;

      ctx.save();
      ctx.globalAlpha = Math.max(0, Math.min(1, p.opacity));
      ctx.translate(p.x, p.y);
      ctx.rotate((p.rotationDeg * Math.PI) / 180);

      if (p.shape === 'emoji') {
        ctx.shadowBlur = 0;
        ctx.font = `${p.size * 2}px serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(p.emoji, 0, 0);
      } else {
        ctx.shadowColor = p.color;
        ctx.shadowBlur = p.shadowBlur;
        ctx.fillStyle = p.color;

        if (p.shape === 'circle') {
          ctx.beginPath();
          ctx.arc(0, 0, p.size * 0.5, 0, Math.PI * 2);
          ctx.fill();
        } else if (p.shape === 'rect') {
          ctx.fillRect(-p.size * 0.6, -p.size * 0.3, p.size * 1.2, p.size * 0.6);
        } else if (p.shape === 'triangle') {
          ctx.beginPath();
          ctx.moveTo(0, -p.size * 0.6);
          ctx.lineTo(-p.size * 0.6, p.size * 0.6);
          ctx.lineTo(p.size * 0.6, p.size * 0.6);
          ctx.closePath();
          ctx.fill();
        }
      }
      ctx.restore();
    }
  }

  function loop(now) {
    // pause-aware delta
    let deltaMs = now - last;
    last = now;

    // avoid spiral of death if tab was hidden
    if (deltaMs > 250) deltaMs = 250;

    accMs += deltaMs;
    while (accMs >= stepMs) {
      update(stepMs / 1000);
      accMs -= stepMs;
      elapsedMs += stepMs;
    }

    render();

    if (elapsedMs < durationMs) {
      raf = requestAnimationFrame(loop);
    } else {
      cancelAnimationFrame(raf);
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    }
  }

  // Start
  cancelAnimationFrame(raf);
  last = performance.now();
  accMs = 0;
  elapsedMs = 0;
  raf = requestAnimationFrame(loop);

  // Optional: stop if user switches tabs for a long time
  document.addEventListener('visibilitychange', () => {
    last = performance.now();
  }, { once: true });
}



document.addEventListener('cart:updated', function(evt) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // ✅ total quantity in cart
      if (cart.item_count === 3) {
        triggerPartyPopper(); // your function
      }
    })
    .catch(error => console.error('Cart fetch failed:', error));
});




// document.addEventListener('ajaxProduct:added', function(evt) {
//   // console.log(evt.detail.product);

//   // Optional: You can also check line items if needed
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//       if (cart.items.length === 2) {
//         // console.log('Cart has exactly 2 line items!');
//         triggerPartyPopper();
//         //  console.log("cartttt dddd", cart);
//       }
//     })
//     .catch(error => console.error('Cart fetch failed:', error));
// });